import React from 'react';
import { Toaster } from 'sonner';
import { LanguageProvider } from './components/LanguageContext';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Services } from './components/Services';
import { Repertoire } from './components/Repertoire';
import { Shows } from './components/Shows';
import { Gallery } from './components/Gallery';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <LanguageProvider data-id="element-0">
      <div className="min-h-screen bg-ink text-cream" data-id="element-1">
        <Nav data-id="element-2" />
        <main data-id="element-3">
          <Hero data-id="element-4" />
          <About data-id="element-5" />
          <Services data-id="element-6" />
          <Contact data-id="element-7" />
          <Repertoire data-id="element-8" />
          <Shows data-id="element-9" />
          <Gallery data-id="element-10" />
        </main>
        <Footer data-id="element-11" />
        <Toaster theme="dark" position="top-center" toastOptions={{
        style: {
          background: '#121212',
          color: '#f5ecd9',
          border: '1px solid rgba(212,164,55,0.3)'
        }
      }} data-id="element-12" />
      </div>
    </LanguageProvider>;
}